import React from 'react';
import renderHtmlContent from '../../../../helpers/renderHtmlContent';
import { is } from 'ramda';

const FormFieldDescription = ({ description }) => {
    return (
        description && (
            <span className="FormField__description">
                {is(String, description) ? renderHtmlContent(description) : description}
            </span>
        )
    );
};

export default FormFieldDescription;